@import "tailwindcss";

html,
body,
#root {
  min-height: 100%;
}

body {
  margin: 0;
}

/* 21st.dev Card Fan Carousel Layout & Card Sizes */
.fan-layout {
  height: 22rem;
}
@media (min-width: 480px) {
  .fan-layout {
    height: 26rem;
  }
}
@media (min-width: 640px) {
  .fan-layout {
    height: 28rem;
  }
}
@media (min-width: 768px) {
  .fan-layout {
    height: 34rem;
  }
}
@media (min-width: 1024px) {
  .fan-layout {
    height: 38rem;
  }
}

.fan-card {
  position: absolute;
  width: 10rem;
  height: 19rem;
  border-radius: 1.25rem;
  overflow: hidden;
  box-shadow: 0 20px 40px -10px rgba(0, 0, 0, 0.5);
}
@media (min-width: 480px) {
  .fan-card {
    width: 12rem;
    height: 22.5rem;
    border-radius: 1.5rem;
  }
}
@media (min-width: 640px) {
  .fan-card {
    width: 13.5rem;
    height: 25rem;
    border-radius: 1.75rem;
  }
}
@media (min-width: 768px) {
  .fan-card {
    width: 16rem;
    height: 30rem;
    border-radius: 2rem;
  }
}
@media (min-width: 1024px) {
  .fan-card {
    width: 18rem;
    height: 34rem;
    border-radius: 2rem;
  }
}
